import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'default',
  icon = null,
  onClick, 
  disabled = false,
  className = '',
  type = 'button',
  fullWidth = false
}) => {
  const baseClasses = 'inline-flex items-center justify-center gap-sm font-body-emphasized transition-quick disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variantClasses = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    outline: 'btn-outline',
    icon: 'btn-icon'
  };
  
  const sizeClasses = {
    small: 'px-lg py-md text-callout',
    default: 'px-xl py-lg',
    large: 'px-xxl py-xl text-body-emphasized'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${className}`}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </button>
  );
};

export default Button;
